import { render } from "./SkeletonBlock.vue?vue&type=template&id=c2f387c4&scoped=true&ts=true"
import script from "./SkeletonBlock.vue?vue&type=script&lang=ts"
export * from "./SkeletonBlock.vue?vue&type=script&lang=ts"

import "./SkeletonBlock.vue?vue&type=style&index=0&id=c2f387c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f387c4"]])

export default __exports__